if (!customElements.get('newsletter-modal')) {
class NewsletterModal extends HTMLElement {
  connectedCallback() {
    const modal = this;
    this.classList.add('newsletter-modal');
    this.setAttribute('role', 'dialog');
    this.setAttribute('aria-modal', 'true');
    this.closeBtn = this.querySelector('.close-btn');
    this.closeBtn?.addEventListener('click' , this.close.bind(modal));

  
    // Close on ESC key
    document.addEventListener('keydown', this.onEscapePress);


    // Optional: auto-focus inside modal
    const focusable = this.querySelector('[autofocus]');
    if (focusable) focusable.focus();
  }

  disconnectedCallback() {
    document.removeEventListener('keydown', this.onEscapePress);
  }

  onOverlayClick = (e) => {
    if (e.target === this) this.close();
  };

  onEscapePress = (e) => {
    if (e.key === 'Escape') this.close();
  };

  close() {
    this.classList.add('hide');

  }
}

customElements.define('newsletter-modal', NewsletterModal);
}
if (!customElements.get('sign-up-button')) {
class SignUpButton extends HTMLElement {
  connectedCallback() {
    this.addEventListener('click', () => {
      const modal = document.querySelector('newsletter-modal');
      if (modal) {
        modal.classList.remove('hide');
      }
    });
  }
}
customElements.define('sign-up-button', SignUpButton);
}